"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ManageSideBar = void 0;
var React = __importStar(require("react"));
var react_1 = require("react");
var react_2 = require("@chakra-ui/react");
var SideBarToggle_1 = require("./SideBarToggle");
var Icon_1 = require("../Icon");
var pro_regular_svg_icons_1 = require("@fortawesome/pro-regular-svg-icons");
var pro_solid_svg_icons_1 = require("@fortawesome/pro-solid-svg-icons");
function ManageSideBar(_a) {
    var sideBar = _a.sideBar, _b = _a.isOpen, isOpen = _b === void 0 ? true : _b, _c = _a.LinkComponent, LinkComponent = _c === void 0 ? react_2.Link : _c, props = __rest(_a, ["sideBar", "isOpen", "LinkComponent"]);
    var _d = (0, react_1.useState)(isOpen), isShown = _d[0], setIsShown = _d[1];
    var groups = sideBar === null || sideBar === void 0 ? void 0 : sideBar.groups;
    var isActive = function (group) { return group['groupInfo']['active']; };
    var sideBarWidth = '250px';
    var sideBarStyling = {
        width: sideBarWidth,
        minWidth: sideBarWidth,
        transition: 'margin 0.5s ease',
        overflowY: 'auto',
        minHeight: 'calc(100vh - 50px)',
        display: 'flex',
        flexDirection: 'column',
    };
    var listStyling = {
        background: '#1f2937',
        margin: 0,
        minWidth: sideBarWidth,
        width: 'auto',
        padding: '50px 0 0 0',
        zIndex: 1,
        display: 'flex',
        flexDirection: 'column',
        flex: 1,
    };
    var groupStyling = {
        lineHeight: 1,
        textAlign: 'left',
    };
    var groupActiveStyling = {
        color: 'silver',
    };
    var expandRowStyling = {
        display: 'block',
        fontSize: '16px',
        fontWeight: 'normal',
        padding: '4px 5px 4px 10px',
        cursor: 'pointer',
        lineHeight: '42px',
        textDecoration: 'none',
    };
    var expandRowHover = {
        color: 'white',
        textDecoration: 'none',
        bg: '#263D62',
    };
    var groupTabStyling = {
        display: 'block',
        padding: '18px 5px 18px 40px',
        textDecoration: 'none',
        transition: 'all 0.15s',
        fontSize: '16px',
    };
    var groupTabActiveStyling = {
        backgroundColor: '#3b82f6',
        color: 'white',
        textShadow: '0 1px 1px rgba(0, 0, 0, 0.3)',
        fontWeight: 'bold',
    };
    var hideSideBarStyling = {
        marginLeft: "-".concat(sideBarWidth),
    };
    var toggleSideBar = function () {
        setIsShown(!isShown);
    };
    return (React.createElement(React.Fragment, null,
        React.createElement(react_2.Box, __assign({ id: "sidebar-wrapper", style: isShown ? sideBarStyling : __assign(__assign({}, sideBarStyling), hideSideBarStyling) }, props),
            React.createElement("ul", { style: listStyling }, groups === null || groups === void 0 ? void 0 : groups.map(function (group) {
                var groupInfo = group['groupInfo'];
                var tabs = group['tabs'];
                var groupActive = isActive(group);
                var icon = groupInfo['active'] ? pro_solid_svg_icons_1.faChevronDown : pro_regular_svg_icons_1.faChevronRight;
                return (React.createElement("li", { key: "manage-group-".concat(groupInfo.groupName), "data-testid": "manage-group-".concat(groupInfo.groupName), className: groupActive ? 'active' : '', style: groupActive
                        ? __assign(__assign({}, groupStyling), groupActiveStyling) : __assign({}, groupStyling) },
                    React.createElement(react_2.Box, { border: "none", color: "silver", borderRadius: "5px", m: "5px", _hover: expandRowHover },
                        React.createElement(LinkComponent, { href: groupInfo['url'], id: groupInfo['elementId'], style: __assign({}, expandRowStyling) },
                            icon && React.createElement(Icon_1.Icon, { type: icon, size: "xs", mr: 2 }),
                            groupInfo['translatedGroupName'])),
                    React.createElement("ul", null, tabs &&
                        Object.keys(tabs).map(function (tabKey) {
                            var tab = tabs[tabKey];
                            return (React.createElement("li", { key: "manage-group-".concat(groupInfo.groupName, "-item-").concat(tabKey), "data-testid": "manage-group-".concat(groupInfo.groupName, "-item-").concat(tabKey), className: tab['active'] ? 'active' : '' },
                                React.createElement(react_2.Box, { borderRadius: "5px", m: "5px", mb: 0, _hover: expandRowHover, overflow: "hidden" },
                                    React.createElement(LinkComponent, { id: tab['elementId'], href: tab['url'], style: tab['active']
                                            ? __assign(__assign({}, groupTabStyling), groupTabActiveStyling) : __assign({}, groupTabStyling) }, tab['translatedName']))));
                        }))));
            }))),
        React.createElement(SideBarToggle_1.SideBarToggle, { onClick: toggleSideBar, isOpen: true })));
}
exports.ManageSideBar = ManageSideBar;
